"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonSlideTaskGapsItemInputbox = void 0;
var enums_1 = require("./enums");
/**
 * Для слайда задания "заполнить пропуски в тексте" - поле ввода
 */
var LessonSlideTaskGapsItemInputbox = /** @class */function () {
  function LessonSlideTaskGapsItemInputbox() {
    this.type = enums_1.LessonTaskGapsEnum.Inputbox;
  }
  return LessonSlideTaskGapsItemInputbox;
}();
exports.LessonSlideTaskGapsItemInputbox = LessonSlideTaskGapsItemInputbox;
